import * as React from 'react';
import {ControlButton, TscButtonType, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import VersionInfoRowContainer from './../VersionInfoRow/VersionInfoRowContainer';
import ReviewVersionModel from '../../types/ReviewVersionModel';
import Strings from '../../globals/Strings';
import {ModalStates} from '../../globals/Constants';

export default ({currentVersionNumber, reviewVersions, setModalState, isOwner, deleteVersion}: VersionsMenuProps) => {
   const handleAddVersionClick = () => {
      setModalState(ModalStates.newVersion);
   };

   const sortedVersions = reviewVersions.filter(ver => !ver.IsDeleted).sort((a: ReviewVersionModel, b: ReviewVersionModel) => b.VersionNumber - a.VersionNumber);

   return (
      <React.Fragment>
         {isOwner && <div className="versions-menu-add">
            <ControlButton buttonType={TscButtonType.primary} glyph={<Glyphs.Add16x16/>} isFullWidth={true} label={Strings.labels.versions.addVersionButtonText} onClick={handleAddVersionClick}/>
         </div>}
         <div className="versions-menu">
            {sortedVersions.map((version: ReviewVersionModel) => <VersionInfoRowContainer key={version.VersionNumber} isSelected={version.VersionNumber === currentVersionNumber} versionInfo={version} deleteVersion={deleteVersion}/>)}
         </div>
      </React.Fragment>
   );
};

export interface VersionsMenuProps {
   reviewVersions: ReviewVersionModel[];
   currentVersionNumber: number;
   reviewId: string;
   isOwner: boolean;
   deleteVersion(version: ReviewVersionModel): void;
   setModalState(modalState: ModalStates): void;
}
